import { useCallback } from 'react'

import type { SyntheticEvent} from 'react';

export interface IPagination {
  pageNumber: number
  totalNumberOfRecords: number
  recordsPerPage: number
  onSetPage: (updatedPageNumber) => void
  onPerPageSelect: (updatedPageNumber) => void
}

interface IUseHandleCurrentPageChanged {
  handleCurrentPageChanged: (event: SyntheticEvent<unknown>) => void
}

export function useHandleCurrentPageChanged(
  onSetPage: (pageNumber) => void,
  recordsPerPage: number,
  totalNumberOfRecords: number,
): IUseHandleCurrentPageChanged {
  const handleCurrentPageChanged = useCallback(
    (event) => {
      // This is because of how Patternfly's pagination widget works.
      // Only if you press enter on the current page input it will update the page number.
      // We have to tie into the onChange and onBlur events to get other changes.
      if (
        event.target.ariaLabel === 'Current page' &&
        event.target.value.trim() !== ''
      ) {
        const pageNumber = parseInt(event.target.value)
        if (!Number.isNaN(pageNumber)) {
          const totalNumberOfPages = Math.ceil(
            totalNumberOfRecords / recordsPerPage,
          )
          if (1 <= pageNumber && pageNumber <= totalNumberOfPages) {
            onSetPage(event.target.value)
          }
        }
      }
    },
    [onSetPage, recordsPerPage, totalNumberOfRecords],
  )

  return {
    handleCurrentPageChanged,
  }
}
